var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function isModuleLikeWithDefaultExport(obj) {
    return (obj !== undefined &&
        obj !== null &&
        typeof obj === 'object' &&
        !Array.isArray(obj) &&
        Object.prototype.hasOwnProperty.call(obj, 'default') &&
        typeof obj['default'] === 'function');
}
function resolveImports(objects, resolvedModules) {
    return __awaiter(this, void 0, void 0, function* () {
        for (const obj of objects) {
            const { chunk, importPath } = obj;
            try {
                const module = yield import(importPath);
                if (!isModuleLikeWithDefaultExport(module)) {
                    const defaultModules = Object.values(module).filter(isModuleLikeWithDefaultExport);
                    if (defaultModules.length) {
                        resolvedModules[chunk] = defaultModules[defaultModules.length - 1];
                    }
                }
                else {
                    resolvedModules[chunk] = module;
                }
                if (!resolvedModules[chunk]) {
                    console.warn(`loadable-ready: unable to determine default export for chunk [${chunk}] - client will re-render`);
                }
            }
            catch (error) {
                console.error(`Failed to import ${chunk} from ${importPath}:`, error);
            }
        }
    });
}
const getRequiredChunks = () => {
    var _a;
    return JSON.parse(((_a = document.getElementById('__LOADABLE_REQUIRED_CHUNKS__')) === null || _a === void 0 ? void 0 : _a.textContent) || '[]');
};
const getNamedChunks = () => {
    var _a;
    return JSON.parse(((_a = document.getElementById('__LOADABLE_REQUIRED_CHUNKS___ext')) === null || _a === void 0 ? void 0 : _a.textContent) || '{"namedChunks":[]}')
        .namedChunks;
};
const loadableReady = (done) => {
    window.__LOADABLE_LOADED_CHUNKS__ = window.__LOADABLE_LOADED_CHUNKS__ || [];
    const loadedChunks = window.__LOADABLE_LOADED_CHUNKS__;
    const originalPush = loadedChunks.push.bind(loadedChunks);
    const requiredChunks = getRequiredChunks();
    let finished = false;
    if (requiredChunks.length) {
        setTimeout(() => {
            if (!finished) {
                console.warn('loadable not ready in time, continuing with hydration');
                finished = true;
                done();
            }
        }, 15000);
    }
    else {
        finished = true;
        done();
        return;
    }
    const checkLoaded = () => {
        if (!requiredChunks.length ||
            requiredChunks.every((chunk) => loadedChunks.some(([chunkName]) => chunkName.indexOf(chunk) > -1))) {
            if (!finished) {
                finished = true;
                window.__LOADABLE_LOADED_MODULES__ = {};
                const namedChunks = getNamedChunks();
                resolveImports(loadedChunks
                    .filter(([chunkName]) => namedChunks.indexOf(chunkName) > -1)
                    .map((loaded) => {
                    return {
                        chunk: loaded[0],
                        importPath: loaded[1].importPath,
                    };
                }), window.__LOADABLE_LOADED_MODULES__)
                    .catch((e) => console.error(e))
                    .finally(done);
            }
        }
    };
    loadedChunks.push = (...args) => {
        const result = originalPush(...args);
        checkLoaded();
        return result;
    };
};
export { loadableReady };
